import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { print } from 'graphql'
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
};

export type BarPage = Document & {
  __typename?: 'BarPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  gallery?: Maybe<Gallery>;
  introText?: Maybe<IntroText>;
  otherLinks?: Maybe<Array<Maybe<LinkWithImage>>>;
  pageCover?: Maybe<PageCover>;
};

export type BarPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  gallery?: InputMaybe<GalleryFilter>;
  introText?: InputMaybe<IntroTextFilter>;
  pageCover?: InputMaybe<PageCoverFilter>;
};

export type BarPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  gallery?: InputMaybe<GallerySorting>;
  introText?: InputMaybe<IntroTextSorting>;
  pageCover?: InputMaybe<PageCoverSorting>;
};

export type Block = {
  __typename?: 'Block';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Span>>>;
  list?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
};

export type BookingPage = Document & {
  __typename?: 'BookingPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  pageCover?: Maybe<PageCover>;
};

export type BookingPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  pageCover?: InputMaybe<PageCoverFilter>;
};

export type BookingPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  pageCover?: InputMaybe<PageCoverSorting>;
};

export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type Carousel = {
  __typename?: 'Carousel';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
};

export type CarouselFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
};

export type CarouselSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};

export type ContactPage = Document & {
  __typename?: 'ContactPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  introText?: Maybe<IntroText>;
  pageCover?: Maybe<PageCover>;
};

export type ContactPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  introText?: InputMaybe<IntroTextFilter>;
  pageCover?: InputMaybe<PageCoverFilter>;
};

export type ContactPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  introText?: InputMaybe<IntroTextSorting>;
  pageCover?: InputMaybe<PageCoverSorting>;
};

export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Date']>;
};

export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** A Sanity document */
export type Document = {
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
};

export type DocumentSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
};

export type EventsPage = Document & {
  __typename?: 'EventsPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  gallery?: Maybe<Gallery>;
  introText?: Maybe<IntroText>;
  otherLinks?: Maybe<Array<Maybe<LinkWithImage>>>;
  pageCover?: Maybe<PageCover>;
};

export type EventsPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  gallery?: InputMaybe<GalleryFilter>;
  introText?: InputMaybe<IntroTextFilter>;
  pageCover?: InputMaybe<PageCoverFilter>;
};

export type EventsPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  gallery?: InputMaybe<GallerySorting>;
  introText?: InputMaybe<IntroTextSorting>;
  pageCover?: InputMaybe<PageCoverSorting>;
};

export type File = {
  __typename?: 'File';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityFileAsset>;
};

export type FileFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityFileAssetFilter>;
};

export type FileSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};

export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Float']>;
};

export type Footer = {
  __typename?: 'Footer';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bottomLinks?: Maybe<Array<Maybe<Link>>>;
  description?: Maybe<LocaleText>;
  logo?: Maybe<Image>;
  quickLinks?: Maybe<Array<Maybe<Link>>>;
};

export type FooterFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  description?: InputMaybe<LocaleTextFilter>;
  logo?: InputMaybe<ImageFilter>;
};

export type FooterSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  description?: InputMaybe<LocaleTextSorting>;
  logo?: InputMaybe<ImageSorting>;
};

export type Gallery = {
  __typename?: 'Gallery';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Image>>>;
  link?: Maybe<Link>;
  sectionTitle?: Maybe<SectionTitle>;
};

export type GalleryFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  link?: InputMaybe<LinkFilter>;
  sectionTitle?: InputMaybe<SectionTitleFilter>;
};

export type GallerySorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  link?: InputMaybe<LinkSorting>;
  sectionTitle?: InputMaybe<SectionTitleSorting>;
};

export type Geopoint = {
  __typename?: 'Geopoint';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type GeopointFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  alt?: InputMaybe<FloatFilter>;
  lat?: InputMaybe<FloatFilter>;
  lng?: InputMaybe<FloatFilter>;
};

export type GeopointSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  alt?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};

export type Header = {
  __typename?: 'Header';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  externalLinks?: Maybe<Array<Maybe<Link>>>;
  logo?: Maybe<Image>;
  navBar?: Maybe<Array<Maybe<Link>>>;
};

export type HeaderFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  logo?: InputMaybe<ImageFilter>;
};

export type HeaderSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  logo?: InputMaybe<ImageSorting>;
};

export type HomePage = Document & {
  __typename?: 'HomePage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  barRestaurant?: Maybe<HomepageBarRestaurant>;
  homepageEvents?: Maybe<HomepageEvents>;
  homepageMeetings?: Maybe<HomepageMeetings>;
  intro?: Maybe<HomepageIntro>;
  roomsCarousel?: Maybe<RoomsCarousel>;
  videoCover?: Maybe<VideoCover>;
};

export type HomePageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  barRestaurant?: InputMaybe<HomepageBarRestaurantFilter>;
  homepageEvents?: InputMaybe<HomepageEventsFilter>;
  homepageMeetings?: InputMaybe<HomepageMeetingsFilter>;
  intro?: InputMaybe<HomepageIntroFilter>;
  roomsCarousel?: InputMaybe<RoomsCarouselFilter>;
  videoCover?: InputMaybe<VideoCoverFilter>;
};

export type HomePageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  barRestaurant?: InputMaybe<HomepageBarRestaurantSorting>;
  homepageEvents?: InputMaybe<HomepageEventsSorting>;
  homepageMeetings?: InputMaybe<HomepageMeetingsSorting>;
  intro?: InputMaybe<HomepageIntroSorting>;
  roomsCarousel?: InputMaybe<RoomsCarouselSorting>;
  videoCover?: InputMaybe<VideoCoverSorting>;
};

export type HomepageBarRestaurant = {
  __typename?: 'HomepageBarRestaurant';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  imagesMatrix?: Maybe<ImagesMatrixWithSlider>;
  sectionTitle?: Maybe<SectionTitle>;
};

export type HomepageBarRestaurantFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  imagesMatrix?: InputMaybe<ImagesMatrixWithSliderFilter>;
  sectionTitle?: InputMaybe<SectionTitleFilter>;
};

export type HomepageBarRestaurantSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  imagesMatrix?: InputMaybe<ImagesMatrixWithSliderSorting>;
  sectionTitle?: InputMaybe<SectionTitleSorting>;
};

export type HomepageEvents = {
  __typename?: 'HomepageEvents';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  carousel?: Maybe<Carousel>;
  link?: Maybe<Link>;
  sectionTitle?: Maybe<SectionTitle>;
};

export type HomepageEventsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  carousel?: InputMaybe<CarouselFilter>;
  link?: InputMaybe<LinkFilter>;
  sectionTitle?: InputMaybe<SectionTitleFilter>;
};

export type HomepageEventsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  carousel?: InputMaybe<CarouselSorting>;
  link?: InputMaybe<LinkSorting>;
  sectionTitle?: InputMaybe<SectionTitleSorting>;
};

export type HomepageIntro = {
  __typename?: 'HomepageIntro';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  description?: Maybe<LocaleBlock>;
  image?: Maybe<Image>;
  subtitle?: Maybe<LocaleString>;
  title?: Maybe<LocaleString>;
};

export type HomepageIntroFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  description?: InputMaybe<LocaleBlockFilter>;
  image?: InputMaybe<ImageFilter>;
  subtitle?: InputMaybe<LocaleStringFilter>;
  title?: InputMaybe<LocaleStringFilter>;
};

export type HomepageIntroSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  description?: InputMaybe<LocaleBlockSorting>;
  image?: InputMaybe<ImageSorting>;
  subtitle?: InputMaybe<LocaleStringSorting>;
  title?: InputMaybe<LocaleStringSorting>;
};

export type HomepageMeetings = {
  __typename?: 'HomepageMeetings';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  images?: Maybe<HomepageMeetingsImages>;
  sectionTitle?: Maybe<SectionTitle>;
  services?: Maybe<HomepageMeetingsServices>;
};

export type HomepageMeetingsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  images?: InputMaybe<HomepageMeetingsImagesFilter>;
  sectionTitle?: InputMaybe<SectionTitleFilter>;
  services?: InputMaybe<HomepageMeetingsServicesFilter>;
};

export type HomepageMeetingsImages = {
  __typename?: 'HomepageMeetingsImages';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  image1?: Maybe<Image>;
  image2?: Maybe<Image>;
  image3?: Maybe<Image>;
  image4?: Maybe<Image>;
  image5?: Maybe<Image>;
};

export type HomepageMeetingsImagesFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  image1?: InputMaybe<ImageFilter>;
  image2?: InputMaybe<ImageFilter>;
  image3?: InputMaybe<ImageFilter>;
  image4?: InputMaybe<ImageFilter>;
  image5?: InputMaybe<ImageFilter>;
};

export type HomepageMeetingsImagesSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  image1?: InputMaybe<ImageSorting>;
  image2?: InputMaybe<ImageSorting>;
  image3?: InputMaybe<ImageSorting>;
  image4?: InputMaybe<ImageSorting>;
  image5?: InputMaybe<ImageSorting>;
};

export type HomepageMeetingsServices = {
  __typename?: 'HomepageMeetingsServices';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  cta?: Maybe<Link>;
  serviceItems?: Maybe<Array<Maybe<ServiceItem>>>;
  title?: Maybe<Scalars['String']>;
};

export type HomepageMeetingsServicesFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  cta?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
};

export type HomepageMeetingsServicesSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  cta?: InputMaybe<LinkSorting>;
  title?: InputMaybe<SortOrder>;
};

export type HomepageMeetingsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  images?: InputMaybe<HomepageMeetingsImagesSorting>;
  sectionTitle?: InputMaybe<SectionTitleSorting>;
  services?: InputMaybe<HomepageMeetingsServicesSorting>;
};

export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['ID']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<Scalars['ID']>>;
};

export type Image = {
  __typename?: 'Image';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
};

export type ImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityImageAssetFilter>;
  crop?: InputMaybe<SanityImageCropFilter>;
  hotspot?: InputMaybe<SanityImageHotspotFilter>;
};

export type ImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  crop?: InputMaybe<SanityImageCropSorting>;
  hotspot?: InputMaybe<SanityImageHotspotSorting>;
};

export type ImagesMatrixWithSlider = {
  __typename?: 'ImagesMatrixWithSlider';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  cta1?: Maybe<Link>;
  cta2?: Maybe<Link>;
  description1?: Maybe<LocaleText>;
  description2?: Maybe<LocaleText>;
  image1?: Maybe<Image>;
  image2?: Maybe<Image>;
  slider?: Maybe<Array<Maybe<Image>>>;
  title1?: Maybe<LocaleString>;
  title2?: Maybe<LocaleString>;
};

export type ImagesMatrixWithSliderFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  cta1?: InputMaybe<LinkFilter>;
  cta2?: InputMaybe<LinkFilter>;
  description1?: InputMaybe<LocaleTextFilter>;
  description2?: InputMaybe<LocaleTextFilter>;
  image1?: InputMaybe<ImageFilter>;
  image2?: InputMaybe<ImageFilter>;
  title1?: InputMaybe<LocaleStringFilter>;
  title2?: InputMaybe<LocaleStringFilter>;
};

export type ImagesMatrixWithSliderSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  cta1?: InputMaybe<LinkSorting>;
  cta2?: InputMaybe<LinkSorting>;
  description1?: InputMaybe<LocaleTextSorting>;
  description2?: InputMaybe<LocaleTextSorting>;
  image1?: InputMaybe<ImageSorting>;
  image2?: InputMaybe<ImageSorting>;
  title1?: InputMaybe<LocaleStringSorting>;
  title2?: InputMaybe<LocaleStringSorting>;
};

export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Int']>;
};

export type IntroText = {
  __typename?: 'IntroText';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  description?: Maybe<LocaleBlock>;
  isCentered?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<LocaleString>;
  title?: Maybe<LocaleString>;
};

export type IntroTextFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  description?: InputMaybe<LocaleBlockFilter>;
  isCentered?: InputMaybe<BooleanFilter>;
  subtitle?: InputMaybe<LocaleStringFilter>;
  title?: InputMaybe<LocaleStringFilter>;
};

export type IntroTextSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  description?: InputMaybe<LocaleBlockSorting>;
  isCentered?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<LocaleStringSorting>;
  title?: InputMaybe<LocaleStringSorting>;
};

export type Link = {
  __typename?: 'Link';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  newTab?: Maybe<Scalars['Boolean']>;
  title?: Maybe<LocaleString>;
  url?: Maybe<Scalars['String']>;
};

export type LinkFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  newTab?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<LocaleStringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type LinkSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  newTab?: InputMaybe<SortOrder>;
  title?: InputMaybe<LocaleStringSorting>;
  url?: InputMaybe<SortOrder>;
};

export type LinkWithImage = {
  __typename?: 'LinkWithImage';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  link?: Maybe<Link>;
};

export type LinkWithImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  link?: InputMaybe<LinkFilter>;
};

export type LinkWithImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  link?: InputMaybe<LinkSorting>;
};

export type LocaleBlock = {
  __typename?: 'LocaleBlock';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  enRaw?: Maybe<Scalars['JSON']>;
  sqRaw?: Maybe<Scalars['JSON']>;
};

export type LocaleBlockFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
};

export type LocaleBlockSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};

export type LocaleString = {
  __typename?: 'LocaleString';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sq?: Maybe<Scalars['String']>;
};

export type LocaleStringFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  en?: InputMaybe<StringFilter>;
  sq?: InputMaybe<StringFilter>;
};

export type LocaleStringSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  en?: InputMaybe<SortOrder>;
  sq?: InputMaybe<SortOrder>;
};

export type LocaleText = {
  __typename?: 'LocaleText';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sq?: Maybe<Scalars['String']>;
};

export type LocaleTextFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  en?: InputMaybe<StringFilter>;
  sq?: InputMaybe<StringFilter>;
};

export type LocaleTextSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  en?: InputMaybe<SortOrder>;
  sq?: InputMaybe<SortOrder>;
};

export type MediaTag = Document & {
  __typename?: 'MediaTag';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Slug>;
};

export type MediaTagFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  name?: InputMaybe<SlugFilter>;
};

export type MediaTagSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SlugSorting>;
};

export type MeetingsPage = Document & {
  __typename?: 'MeetingsPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  gallery?: Maybe<Gallery>;
  introText?: Maybe<IntroText>;
  otherLinks?: Maybe<Array<Maybe<LinkWithImage>>>;
  pageCover?: Maybe<PageCover>;
};

export type MeetingsPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  gallery?: InputMaybe<GalleryFilter>;
  introText?: InputMaybe<IntroTextFilter>;
  pageCover?: InputMaybe<PageCoverFilter>;
};

export type MeetingsPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  gallery?: InputMaybe<GallerySorting>;
  introText?: InputMaybe<IntroTextSorting>;
  pageCover?: InputMaybe<PageCoverSorting>;
};

export type NavBarItem = {
  __typename?: 'NavBarItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  title?: Maybe<LocaleString>;
  url?: Maybe<Scalars['String']>;
};

export type NavBarItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  title?: InputMaybe<LocaleStringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type NavBarItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  title?: InputMaybe<LocaleStringSorting>;
  url?: InputMaybe<SortOrder>;
};

export type PageCover = {
  __typename?: 'PageCover';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  cover_image?: Maybe<Image>;
  title?: Maybe<LocaleString>;
};

export type PageCoverFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  cover_image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<LocaleStringFilter>;
};

export type PageCoverSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  cover_image?: InputMaybe<ImageSorting>;
  title?: InputMaybe<LocaleStringSorting>;
};

export type Price = {
  __typename?: 'Price';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  price?: Maybe<LocaleString>;
  show_price?: Maybe<Scalars['Boolean']>;
};

export type PriceFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  price?: InputMaybe<LocaleStringFilter>;
  show_price?: InputMaybe<BooleanFilter>;
};

export type PriceSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  price?: InputMaybe<LocaleStringSorting>;
  show_price?: InputMaybe<SortOrder>;
};

export type RestaurantPage = Document & {
  __typename?: 'RestaurantPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  carousel?: Maybe<Carousel>;
  gallery?: Maybe<Gallery>;
  introText?: Maybe<IntroText>;
  otherLinks?: Maybe<Array<Maybe<LinkWithImage>>>;
  videoCover?: Maybe<VideoCover>;
};

export type RestaurantPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  carousel?: InputMaybe<CarouselFilter>;
  gallery?: InputMaybe<GalleryFilter>;
  introText?: InputMaybe<IntroTextFilter>;
  videoCover?: InputMaybe<VideoCoverFilter>;
};

export type RestaurantPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  carousel?: InputMaybe<CarouselSorting>;
  gallery?: InputMaybe<GallerySorting>;
  introText?: InputMaybe<IntroTextSorting>;
  videoCover?: InputMaybe<VideoCoverSorting>;
};

export type Room = Document & {
  __typename?: 'Room';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  additionalInfo?: Maybe<LocaleBlock>;
  beRoomType?: Maybe<Scalars['String']>;
  beds?: Maybe<LocaleString>;
  coverImage?: Maybe<Image>;
  description?: Maybe<LocaleBlock>;
  hasBalcony?: Maybe<Scalars['Boolean']>;
  images?: Maybe<Array<Maybe<Image>>>;
  name?: Maybe<LocaleString>;
  note?: Maybe<LocaleBlock>;
  price?: Maybe<Price>;
  room_features?: Maybe<Array<Maybe<RoomFeatures>>>;
  shortDescription?: Maybe<LocaleText>;
  slug?: Maybe<Slug>;
};

export type RoomFeatures = Document & {
  __typename?: 'RoomFeatures';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<LocaleString>;
};

export type RoomFeaturesFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  icon?: InputMaybe<StringFilter>;
  name?: InputMaybe<LocaleStringFilter>;
};

export type RoomFeaturesSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  name?: InputMaybe<LocaleStringSorting>;
};

export type RoomFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  additionalInfo?: InputMaybe<LocaleBlockFilter>;
  beRoomType?: InputMaybe<StringFilter>;
  beds?: InputMaybe<LocaleStringFilter>;
  coverImage?: InputMaybe<ImageFilter>;
  description?: InputMaybe<LocaleBlockFilter>;
  hasBalcony?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<LocaleStringFilter>;
  note?: InputMaybe<LocaleBlockFilter>;
  price?: InputMaybe<PriceFilter>;
  shortDescription?: InputMaybe<LocaleTextFilter>;
  slug?: InputMaybe<SlugFilter>;
};

export type RoomSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  additionalInfo?: InputMaybe<LocaleBlockSorting>;
  beRoomType?: InputMaybe<SortOrder>;
  beds?: InputMaybe<LocaleStringSorting>;
  coverImage?: InputMaybe<ImageSorting>;
  description?: InputMaybe<LocaleBlockSorting>;
  hasBalcony?: InputMaybe<SortOrder>;
  name?: InputMaybe<LocaleStringSorting>;
  note?: InputMaybe<LocaleBlockSorting>;
  price?: InputMaybe<PriceSorting>;
  shortDescription?: InputMaybe<LocaleTextSorting>;
  slug?: InputMaybe<SlugSorting>;
};

export type RoomsCarousel = {
  __typename?: 'RoomsCarousel';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  rooms?: Maybe<Array<Maybe<Room>>>;
  sectionTitle?: Maybe<SectionTitle>;
};

export type RoomsCarouselFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  sectionTitle?: InputMaybe<SectionTitleFilter>;
};

export type RoomsCarouselSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  sectionTitle?: InputMaybe<SectionTitleSorting>;
};

export type RoomsListPage = Document & {
  __typename?: 'RoomsListPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  pageCover?: Maybe<PageCover>;
};

export type RoomsListPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  pageCover?: InputMaybe<PageCoverFilter>;
};

export type RoomsListPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  pageCover?: InputMaybe<PageCoverSorting>;
};

export type RootQuery = {
  __typename?: 'RootQuery';
  BarPage?: Maybe<BarPage>;
  BookingPage?: Maybe<BookingPage>;
  ContactPage?: Maybe<ContactPage>;
  Document?: Maybe<Document>;
  EventsPage?: Maybe<EventsPage>;
  HomePage?: Maybe<HomePage>;
  MediaTag?: Maybe<MediaTag>;
  MeetingsPage?: Maybe<MeetingsPage>;
  RestaurantPage?: Maybe<RestaurantPage>;
  Room?: Maybe<Room>;
  RoomFeatures?: Maybe<RoomFeatures>;
  RoomsListPage?: Maybe<RoomsListPage>;
  SanityFileAsset?: Maybe<SanityFileAsset>;
  SanityImageAsset?: Maybe<SanityImageAsset>;
  SiteSettings?: Maybe<SiteSettings>;
  allBarPage: Array<BarPage>;
  allBookingPage: Array<BookingPage>;
  allContactPage: Array<ContactPage>;
  allDocument: Array<Document>;
  allEventsPage: Array<EventsPage>;
  allHomePage: Array<HomePage>;
  allMediaTag: Array<MediaTag>;
  allMeetingsPage: Array<MeetingsPage>;
  allRestaurantPage: Array<RestaurantPage>;
  allRoom: Array<Room>;
  allRoomFeatures: Array<RoomFeatures>;
  allRoomsListPage: Array<RoomsListPage>;
  allSanityFileAsset: Array<SanityFileAsset>;
  allSanityImageAsset: Array<SanityImageAsset>;
  allSiteSettings: Array<SiteSettings>;
};


export type RootQueryBarPageArgs = {
  id: Scalars['ID'];
};


export type RootQueryBookingPageArgs = {
  id: Scalars['ID'];
};


export type RootQueryContactPageArgs = {
  id: Scalars['ID'];
};


export type RootQueryDocumentArgs = {
  id: Scalars['ID'];
};


export type RootQueryEventsPageArgs = {
  id: Scalars['ID'];
};


export type RootQueryHomePageArgs = {
  id: Scalars['ID'];
};


export type RootQueryMediaTagArgs = {
  id: Scalars['ID'];
};


export type RootQueryMeetingsPageArgs = {
  id: Scalars['ID'];
};


export type RootQueryRestaurantPageArgs = {
  id: Scalars['ID'];
};


export type RootQueryRoomArgs = {
  id: Scalars['ID'];
};


export type RootQueryRoomFeaturesArgs = {
  id: Scalars['ID'];
};


export type RootQueryRoomsListPageArgs = {
  id: Scalars['ID'];
};


export type RootQuerySanityFileAssetArgs = {
  id: Scalars['ID'];
};


export type RootQuerySanityImageAssetArgs = {
  id: Scalars['ID'];
};


export type RootQuerySiteSettingsArgs = {
  id: Scalars['ID'];
};


export type RootQueryAllBarPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<BarPageSorting>>;
  where?: InputMaybe<BarPageFilter>;
};


export type RootQueryAllBookingPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<BookingPageSorting>>;
  where?: InputMaybe<BookingPageFilter>;
};


export type RootQueryAllContactPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ContactPageSorting>>;
  where?: InputMaybe<ContactPageFilter>;
};


export type RootQueryAllDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<DocumentSorting>>;
  where?: InputMaybe<DocumentFilter>;
};


export type RootQueryAllEventsPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<EventsPageSorting>>;
  where?: InputMaybe<EventsPageFilter>;
};


export type RootQueryAllHomePageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<HomePageSorting>>;
  where?: InputMaybe<HomePageFilter>;
};


export type RootQueryAllMediaTagArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MediaTagSorting>>;
  where?: InputMaybe<MediaTagFilter>;
};


export type RootQueryAllMeetingsPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MeetingsPageSorting>>;
  where?: InputMaybe<MeetingsPageFilter>;
};


export type RootQueryAllRestaurantPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<RestaurantPageSorting>>;
  where?: InputMaybe<RestaurantPageFilter>;
};


export type RootQueryAllRoomArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<RoomSorting>>;
  where?: InputMaybe<RoomFilter>;
};


export type RootQueryAllRoomFeaturesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<RoomFeaturesSorting>>;
  where?: InputMaybe<RoomFeaturesFilter>;
};


export type RootQueryAllRoomsListPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<RoomsListPageSorting>>;
  where?: InputMaybe<RoomsListPageFilter>;
};


export type RootQueryAllSanityFileAssetArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SanityFileAssetSorting>>;
  where?: InputMaybe<SanityFileAssetFilter>;
};


export type RootQueryAllSanityImageAssetArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SanityImageAssetSorting>>;
  where?: InputMaybe<SanityImageAssetFilter>;
};


export type RootQueryAllSiteSettingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SiteSettingsSorting>>;
  where?: InputMaybe<SiteSettingsFilter>;
};

export type SanityAssetSourceData = {
  __typename?: 'SanityAssetSourceData';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']>;
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']>;
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']>;
};

export type SanityAssetSourceDataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityAssetSourceDataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityFileAsset = Document & {
  __typename?: 'SanityFileAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityFileAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityImageAsset = Document & {
  __typename?: 'SanityImageAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<SanityImageMetadata>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  uploadId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<SanityImageMetadataFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  uploadId?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityImageAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SanityImageMetadataSorting>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  uploadId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityImageCrop = {
  __typename?: 'SanityImageCrop';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
};

export type SanityImageCropFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  bottom?: InputMaybe<FloatFilter>;
  left?: InputMaybe<FloatFilter>;
  right?: InputMaybe<FloatFilter>;
  top?: InputMaybe<FloatFilter>;
};

export type SanityImageCropSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  bottom?: InputMaybe<SortOrder>;
  left?: InputMaybe<SortOrder>;
  right?: InputMaybe<SortOrder>;
  top?: InputMaybe<SortOrder>;
};

export type SanityImageDimensions = {
  __typename?: 'SanityImageDimensions';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type SanityImageDimensionsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<FloatFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type SanityImageDimensionsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  aspectRatio?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type SanityImageHotspotFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
  x?: InputMaybe<FloatFilter>;
  y?: InputMaybe<FloatFilter>;
};

export type SanityImageHotspotSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
  x?: InputMaybe<SortOrder>;
  y?: InputMaybe<SortOrder>;
};

export type SanityImageMetadata = {
  __typename?: 'SanityImageMetadata';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  blurHash?: Maybe<Scalars['String']>;
  dimensions?: Maybe<SanityImageDimensions>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  isOpaque?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Geopoint>;
  lqip?: Maybe<Scalars['String']>;
  palette?: Maybe<SanityImagePalette>;
};

export type SanityImageMetadataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  blurHash?: InputMaybe<StringFilter>;
  dimensions?: InputMaybe<SanityImageDimensionsFilter>;
  hasAlpha?: InputMaybe<BooleanFilter>;
  isOpaque?: InputMaybe<BooleanFilter>;
  location?: InputMaybe<GeopointFilter>;
  lqip?: InputMaybe<StringFilter>;
  palette?: InputMaybe<SanityImagePaletteFilter>;
};

export type SanityImageMetadataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  blurHash?: InputMaybe<SortOrder>;
  dimensions?: InputMaybe<SanityImageDimensionsSorting>;
  hasAlpha?: InputMaybe<SortOrder>;
  isOpaque?: InputMaybe<SortOrder>;
  location?: InputMaybe<GeopointSorting>;
  lqip?: InputMaybe<SortOrder>;
  palette?: InputMaybe<SanityImagePaletteSorting>;
};

export type SanityImagePalette = {
  __typename?: 'SanityImagePalette';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
};

export type SanityImagePaletteFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  dominant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  muted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
};

export type SanityImagePaletteSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  dominant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  muted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
};

export type SanityImagePaletteSwatch = {
  __typename?: 'SanityImagePaletteSwatch';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  foreground?: Maybe<Scalars['String']>;
  population?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type SanityImagePaletteSwatchFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  background?: InputMaybe<StringFilter>;
  foreground?: InputMaybe<StringFilter>;
  population?: InputMaybe<FloatFilter>;
  title?: InputMaybe<StringFilter>;
};

export type SanityImagePaletteSwatchSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  background?: InputMaybe<SortOrder>;
  foreground?: InputMaybe<SortOrder>;
  population?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type Sanity_DocumentFilter = {
  /** All documents that are drafts. */
  is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents referencing the given document ID. */
  references?: InputMaybe<Scalars['ID']>;
};

export type SectionTitle = {
  __typename?: 'SectionTitle';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  description?: Maybe<LocaleText>;
  title?: Maybe<LocaleString>;
};

export type SectionTitleFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  description?: InputMaybe<LocaleTextFilter>;
  title?: InputMaybe<LocaleStringFilter>;
};

export type SectionTitleSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  description?: InputMaybe<LocaleTextSorting>;
  title?: InputMaybe<LocaleStringSorting>;
};

export type ServiceItem = {
  __typename?: 'ServiceItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  icon?: Maybe<Image>;
  title?: Maybe<LocaleString>;
};

export type ServiceItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  icon?: InputMaybe<ImageFilter>;
  title?: InputMaybe<LocaleStringFilter>;
};

export type ServiceItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  icon?: InputMaybe<ImageSorting>;
  title?: InputMaybe<LocaleStringSorting>;
};

export type SiteSettings = Document & {
  __typename?: 'SiteSettings';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  address?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  footer?: Maybe<Footer>;
  header?: Maybe<Header>;
  instagram?: Maybe<Scalars['String']>;
  mapIframe?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
};

export type SiteSettingsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  address?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  facebook?: InputMaybe<StringFilter>;
  fax?: InputMaybe<StringFilter>;
  footer?: InputMaybe<FooterFilter>;
  header?: InputMaybe<HeaderFilter>;
  instagram?: InputMaybe<StringFilter>;
  mapIframe?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  web?: InputMaybe<StringFilter>;
};

export type SiteSettingsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebook?: InputMaybe<SortOrder>;
  fax?: InputMaybe<SortOrder>;
  footer?: InputMaybe<FooterSorting>;
  header?: InputMaybe<HeaderSorting>;
  instagram?: InputMaybe<SortOrder>;
  mapIframe?: InputMaybe<SortOrder>;
  mobile?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  web?: InputMaybe<SortOrder>;
};

export type Slug = {
  __typename?: 'Slug';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type SlugFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  current?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
};

export type SlugSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  current?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  /** Sorts on the value in ascending order. */
  Asc = 'ASC',
  /** Sorts on the value in descending order. */
  Desc = 'DESC'
}

export type Span = {
  __typename?: 'Span';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['String']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<Scalars['String']>>;
};

export type VideoCover = {
  __typename?: 'VideoCover';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Background video */
  iframe?: Maybe<Scalars['String']>;
};

export type VideoCoverFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  iframe?: InputMaybe<StringFilter>;
};

export type VideoCoverSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  iframe?: InputMaybe<SortOrder>;
};

export type GetBarPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBarPageQuery = { __typename?: 'RootQuery', BarPage?: { __typename?: 'BarPage', _id?: string | null, pageCover?: { __typename?: 'PageCover', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, cover_image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null, introText?: { __typename?: 'IntroText', isCentered?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null } | null, gallery?: { __typename?: 'Gallery', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null, otherLinks?: Array<{ __typename?: 'LinkWithImage', link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null> | null } | null };

export type GetBookingPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookingPageQuery = { __typename?: 'RootQuery', BookingPage?: { __typename?: 'BookingPage', _id?: string | null, pageCover?: { __typename?: 'PageCover', cover_image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null };

export type GetContactPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactPageQuery = { __typename?: 'RootQuery', ContactPage?: { __typename?: 'ContactPage', _id?: string | null, pageCover?: { __typename?: 'PageCover', cover_image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, introText?: { __typename?: 'IntroText', isCentered?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null } | null } | null };

export type GetEventsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventsPageQuery = { __typename?: 'RootQuery', EventsPage?: { __typename?: 'EventsPage', _id?: string | null, pageCover?: { __typename?: 'PageCover', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, cover_image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null, introText?: { __typename?: 'IntroText', isCentered?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null } | null, gallery?: { __typename?: 'Gallery', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null, otherLinks?: Array<{ __typename?: 'LinkWithImage', link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null> | null } | null };

export type LocaleStringFragmentFragment = { __typename?: 'LocaleString', en?: string | null, sq?: string | null };

export type LocaleTextFragmentFragment = { __typename?: 'LocaleText', en?: string | null, sq?: string | null };

export type LocaleBlockFragmentFragment = { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null };

export type SectionTitleFragmentFragment = { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null };

export type ImageFragmentFragment = { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null };

export type LinkFragmentFragment = { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null };

export type IntroTextFragmentFragment = { __typename?: 'IntroText', isCentered?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null };

export type CarouselFragmentFragment = { __typename?: 'Carousel', images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null };

export type GalleryFragmentFragment = { __typename?: 'Gallery', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null };

export type LinkWithImageFragmentFragment = { __typename?: 'LinkWithImage', link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null };

export type GetHomepageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomepageDataQuery = { __typename?: 'RootQuery', HomePage?: { __typename?: 'HomePage', _id?: string | null, intro?: { __typename?: 'HomepageIntro', _key?: string | null, _type?: string | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null, videoCover?: { __typename?: 'VideoCover', iframe?: string | null } | null, roomsCarousel?: { __typename?: 'RoomsCarousel', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, rooms?: Array<{ __typename?: 'Room', _id?: string | null, hasBalcony?: boolean | null, shortDescription?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, beds?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, slug?: { __typename?: 'Slug', _key?: string | null, current?: string | null, source?: string | null } | null, coverImage?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null> | null } | null, homepageMeetings?: { __typename?: 'HomepageMeetings', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, images?: { __typename?: 'HomepageMeetingsImages', image1?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, image2?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, image3?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, image4?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, image5?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null, services?: { __typename?: 'HomepageMeetingsServices', title?: string | null, _key?: string | null, _type?: string | null, serviceItems?: Array<{ __typename?: 'ServiceItem', _key?: string | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, icon?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null> | null, cta?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null } | null, barRestaurant?: { __typename?: 'HomepageBarRestaurant', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, imagesMatrix?: { __typename?: 'ImagesMatrixWithSlider', image1?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, title1?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description1?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, cta1?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, image2?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, title2?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description2?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, cta2?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, slider?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null } | null } | null, homepageEvents?: { __typename?: 'HomepageEvents', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, carousel?: { __typename?: 'Carousel', images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null } | null, link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null } | null };

export type GetMeetingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeetingsPageQuery = { __typename?: 'RootQuery', MeetingsPage?: { __typename?: 'MeetingsPage', _id?: string | null, pageCover?: { __typename?: 'PageCover', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, cover_image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null, introText?: { __typename?: 'IntroText', isCentered?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null } | null, gallery?: { __typename?: 'Gallery', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null, otherLinks?: Array<{ __typename?: 'LinkWithImage', link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null> | null } | null };

export type GetRestaurantPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRestaurantPageQuery = { __typename?: 'RootQuery', RestaurantPage?: { __typename?: 'RestaurantPage', _id?: string | null, videoCover?: { __typename?: 'VideoCover', iframe?: string | null } | null, introText?: { __typename?: 'IntroText', isCentered?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, subtitle?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null } | null, carousel?: { __typename?: 'Carousel', images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null } | null, gallery?: { __typename?: 'Gallery', sectionTitle?: { __typename?: 'SectionTitle', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null } | null, otherLinks?: Array<{ __typename?: 'LinkWithImage', link?: { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null> | null } | null };

export type RoomDetailsFragment = { __typename?: 'Room', _id?: string | null, hasBalcony?: boolean | null, beRoomType?: string | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, note?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, beds?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, coverImage?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, price?: { __typename?: 'Price', show_price?: boolean | null, price?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, slug?: { __typename?: 'Slug', current?: string | null, source?: string | null } | null, shortDescription?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, additionalInfo?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, room_features?: Array<{ __typename?: 'RoomFeatures', _id?: string | null, _type?: string | null, _key?: string | null, icon?: string | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null> | null };

export type GetRoomBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetRoomBySlugQuery = { __typename?: 'RootQuery', allRoom: Array<{ __typename?: 'Room', _id?: string | null, hasBalcony?: boolean | null, beRoomType?: string | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, note?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, beds?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, coverImage?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, price?: { __typename?: 'Price', show_price?: boolean | null, price?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, slug?: { __typename?: 'Slug', current?: string | null, source?: string | null } | null, shortDescription?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, additionalInfo?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, room_features?: Array<{ __typename?: 'RoomFeatures', _id?: string | null, _type?: string | null, _key?: string | null, icon?: string | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null> | null }> };

export type GetRoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomsQuery = { __typename?: 'RootQuery', allRoom: Array<{ __typename?: 'Room', _id?: string | null, hasBalcony?: boolean | null, beRoomType?: string | null, description?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, note?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, beds?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, images?: Array<{ __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null> | null, coverImage?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, price?: { __typename?: 'Price', show_price?: boolean | null, price?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null, slug?: { __typename?: 'Slug', current?: string | null, source?: string | null } | null, shortDescription?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, additionalInfo?: { __typename?: 'LocaleBlock', enRaw?: any | null, sqRaw?: any | null } | null, room_features?: Array<{ __typename?: 'RoomFeatures', _id?: string | null, _type?: string | null, _key?: string | null, icon?: string | null, name?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null> | null }> };

export type GetRoomsListPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoomsListPageQuery = { __typename?: 'RootQuery', RoomsListPage?: { __typename?: 'RoomsListPage', _id?: string | null, pageCover?: { __typename?: 'PageCover', title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null, cover_image?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null } | null } | null };

export type ImageFragment = { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null };

export type LinkFragment = { __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null };

export type GetSiteSettignsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteSettignsQuery = { __typename?: 'RootQuery', SiteSettings?: { __typename?: 'SiteSettings', _id?: string | null, title?: string | null, description?: string | null, email?: string | null, mobile?: string | null, fax?: string | null, web?: string | null, address?: string | null, facebook?: string | null, instagram?: string | null, mapIframe?: string | null, header?: { __typename?: 'Header', _key?: string | null, _type?: string | null, logo?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, navBar?: Array<{ __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null> | null, externalLinks?: Array<{ __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null> | null } | null, footer?: { __typename?: 'Footer', _key?: string | null, logo?: { __typename?: 'Image', _key?: string | null, asset?: { __typename?: 'SanityImageAsset', altText?: string | null, assetId?: string | null, url?: string | null, _key?: string | null } | null } | null, description?: { __typename?: 'LocaleText', en?: string | null, sq?: string | null } | null, quickLinks?: Array<{ __typename?: 'Link', _key?: string | null, url?: string | null, newTab?: boolean | null, title?: { __typename?: 'LocaleString', en?: string | null, sq?: string | null } | null } | null> | null } | null } | null };

export const LocaleStringFragmentFragmentDoc = gql`
    fragment LocaleStringFragment on LocaleString {
  en
  sq
}
    `;
export const LocaleBlockFragmentFragmentDoc = gql`
    fragment LocaleBlockFragment on LocaleBlock {
  enRaw
  sqRaw
}
    `;
export const IntroTextFragmentFragmentDoc = gql`
    fragment IntroTextFragment on IntroText {
  title {
    ...LocaleStringFragment
  }
  subtitle {
    ...LocaleStringFragment
  }
  description {
    ...LocaleBlockFragment
  }
  isCentered
}
    ${LocaleStringFragmentFragmentDoc}
${LocaleBlockFragmentFragmentDoc}`;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Image {
  _key
  asset {
    altText
    assetId
    url
    _key
  }
}
    `;
export const CarouselFragmentFragmentDoc = gql`
    fragment CarouselFragment on Carousel {
  images {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const LocaleTextFragmentFragmentDoc = gql`
    fragment LocaleTextFragment on LocaleText {
  en
  sq
}
    `;
export const SectionTitleFragmentFragmentDoc = gql`
    fragment SectionTitleFragment on SectionTitle {
  title {
    ...LocaleStringFragment
  }
  description {
    ...LocaleTextFragment
  }
}
    ${LocaleStringFragmentFragmentDoc}
${LocaleTextFragmentFragmentDoc}`;
export const LinkFragmentFragmentDoc = gql`
    fragment LinkFragment on Link {
  _key
  title {
    ...LocaleStringFragment
  }
  url
  newTab
}
    ${LocaleStringFragmentFragmentDoc}`;
export const GalleryFragmentFragmentDoc = gql`
    fragment GalleryFragment on Gallery {
  sectionTitle {
    ...SectionTitleFragment
  }
  images {
    ...ImageFragment
  }
  link {
    ...LinkFragment
  }
}
    ${SectionTitleFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const LinkWithImageFragmentFragmentDoc = gql`
    fragment LinkWithImageFragment on LinkWithImage {
  link {
    ...LinkFragment
  }
  image {
    ...ImageFragment
  }
}
    ${LinkFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const RoomDetailsFragmentDoc = gql`
    fragment RoomDetails on Room {
  _id
  description {
    ...LocaleBlockFragment
  }
  note {
    ...LocaleBlockFragment
  }
  beds {
    ...LocaleStringFragment
  }
  hasBalcony
  images {
    ...ImageFragment
  }
  coverImage {
    ...ImageFragment
  }
  name {
    ...LocaleStringFragment
  }
  beRoomType
  price {
    price {
      ...LocaleStringFragment
    }
    show_price
  }
  slug {
    current
    source
  }
  shortDescription {
    ...LocaleTextFragment
  }
  additionalInfo {
    ...LocaleBlockFragment
  }
  room_features {
    _id
    _type
    _key
    name {
      ...LocaleStringFragment
    }
    icon
  }
}
    ${LocaleBlockFragmentFragmentDoc}
${LocaleStringFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${LocaleTextFragmentFragmentDoc}`;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  _key
  asset {
    altText
    assetId
    url
    _key
  }
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on Link {
  _key
  title {
    en
    sq
  }
  url
  newTab
}
    `;
export const GetBarPageDocument = gql`
    query getBarPage {
  BarPage(id: "barPage") {
    _id
    pageCover {
      title {
        ...LocaleStringFragment
      }
      cover_image {
        ...ImageFragment
      }
    }
    introText {
      ...IntroTextFragment
    }
    gallery {
      ...GalleryFragment
    }
    otherLinks {
      ...LinkWithImageFragment
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${IntroTextFragmentFragmentDoc}
${GalleryFragmentFragmentDoc}
${LinkWithImageFragmentFragmentDoc}`;
export const GetBookingPageDocument = gql`
    query getBookingPage {
  BookingPage(id: "bookingPage") {
    _id
    pageCover {
      cover_image {
        ...ImageFragment
      }
      title {
        ...LocaleStringFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${LocaleStringFragmentFragmentDoc}`;
export const GetContactPageDocument = gql`
    query getContactPage {
  ContactPage(id: "contactPage") {
    _id
    pageCover {
      cover_image {
        ...ImageFragment
      }
      title {
        ...LocaleStringFragment
      }
    }
    introText {
      ...IntroTextFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${LocaleStringFragmentFragmentDoc}
${IntroTextFragmentFragmentDoc}`;
export const GetEventsPageDocument = gql`
    query getEventsPage {
  EventsPage(id: "eventsPage") {
    _id
    pageCover {
      title {
        ...LocaleStringFragment
      }
      cover_image {
        ...ImageFragment
      }
    }
    introText {
      ...IntroTextFragment
    }
    gallery {
      ...GalleryFragment
    }
    otherLinks {
      ...LinkWithImageFragment
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${IntroTextFragmentFragmentDoc}
${GalleryFragmentFragmentDoc}
${LinkWithImageFragmentFragmentDoc}`;
export const GetHomepageDataDocument = gql`
    query getHomepageData {
  HomePage(id: "homePage") {
    _id
    intro {
      _key
      _type
      title {
        ...LocaleStringFragment
      }
      subtitle {
        ...LocaleStringFragment
      }
      description {
        ...LocaleBlockFragment
      }
      image {
        ...ImageFragment
      }
    }
    videoCover {
      iframe
    }
    roomsCarousel {
      sectionTitle {
        ...SectionTitleFragment
      }
      rooms {
        _id
        shortDescription {
          ...LocaleTextFragment
        }
        name {
          ...LocaleStringFragment
        }
        beds {
          ...LocaleStringFragment
        }
        hasBalcony
        slug {
          _key
          current
          source
        }
        coverImage {
          ...ImageFragment
        }
      }
    }
    homepageMeetings {
      sectionTitle {
        ...SectionTitleFragment
      }
      images {
        image1 {
          ...ImageFragment
        }
        image2 {
          ...ImageFragment
        }
        image3 {
          ...ImageFragment
        }
        image4 {
          ...ImageFragment
        }
        image5 {
          ...ImageFragment
        }
      }
      services {
        title
        _key
        _type
        serviceItems {
          title {
            ...LocaleStringFragment
          }
          _key
          icon {
            ...ImageFragment
          }
        }
        cta {
          ...LinkFragment
        }
      }
    }
    barRestaurant {
      sectionTitle {
        ...SectionTitleFragment
      }
      imagesMatrix {
        image1 {
          ...ImageFragment
        }
        title1 {
          ...LocaleStringFragment
        }
        description1 {
          ...LocaleTextFragment
        }
        cta1 {
          ...LinkFragment
        }
        image2 {
          ...ImageFragment
        }
        title2 {
          ...LocaleStringFragment
        }
        description2 {
          ...LocaleTextFragment
        }
        cta2 {
          ...LinkFragment
        }
        slider {
          ...ImageFragment
        }
      }
    }
    homepageEvents {
      sectionTitle {
        ...SectionTitleFragment
      }
      carousel {
        ...CarouselFragment
      }
      link {
        ...Link
      }
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}
${LocaleBlockFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${SectionTitleFragmentFragmentDoc}
${LocaleTextFragmentFragmentDoc}
${LinkFragmentFragmentDoc}
${CarouselFragmentFragmentDoc}
${LinkFragmentDoc}`;
export const GetMeetingsPageDocument = gql`
    query getMeetingsPage {
  MeetingsPage(id: "meetingsPage") {
    _id
    pageCover {
      title {
        ...LocaleStringFragment
      }
      cover_image {
        ...ImageFragment
      }
    }
    introText {
      ...IntroTextFragment
    }
    gallery {
      ...GalleryFragment
    }
    otherLinks {
      ...LinkWithImageFragment
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${IntroTextFragmentFragmentDoc}
${GalleryFragmentFragmentDoc}
${LinkWithImageFragmentFragmentDoc}`;
export const GetRestaurantPageDocument = gql`
    query getRestaurantPage {
  RestaurantPage(id: "restaurantPage") {
    _id
    videoCover {
      iframe
    }
    introText {
      ...IntroTextFragment
    }
    carousel {
      ...CarouselFragment
    }
    gallery {
      ...GalleryFragment
    }
    otherLinks {
      ...LinkWithImageFragment
    }
  }
}
    ${IntroTextFragmentFragmentDoc}
${CarouselFragmentFragmentDoc}
${GalleryFragmentFragmentDoc}
${LinkWithImageFragmentFragmentDoc}`;
export const GetRoomBySlugDocument = gql`
    query getRoomBySlug($slug: String) {
  allRoom(where: {slug: {current: {eq: $slug}}}) {
    ...RoomDetails
  }
}
    ${RoomDetailsFragmentDoc}`;
export const GetRoomsDocument = gql`
    query getRooms {
  allRoom {
    ...RoomDetails
  }
}
    ${RoomDetailsFragmentDoc}`;
export const GetRoomsListPageDocument = gql`
    query getRoomsListPage {
  RoomsListPage(id: "roomsListPage") {
    _id
    pageCover {
      title {
        ...LocaleStringFragment
      }
      cover_image {
        ...ImageFragment
      }
    }
  }
}
    ${LocaleStringFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const GetSiteSettignsDocument = gql`
    query getSiteSettigns {
  SiteSettings(id: "siteSettings") {
    _id
    title
    description
    email
    mobile
    fax
    web
    address
    facebook
    instagram
    mapIframe
    header {
      _key
      _type
      logo {
        ...Image
      }
      navBar {
        ...Link
      }
      externalLinks {
        ...Link
      }
    }
    footer {
      _key
      logo {
        ...ImageFragment
      }
      description {
        ...LocaleTextFragment
      }
      quickLinks {
        _key
        title {
          ...LocaleStringFragment
        }
        url
        newTab
      }
    }
  }
}
    ${ImageFragmentDoc}
${LinkFragmentDoc}
${ImageFragmentFragmentDoc}
${LocaleTextFragmentFragmentDoc}
${LocaleStringFragmentFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();
const GetBarPageDocumentString = print(GetBarPageDocument);
const GetBookingPageDocumentString = print(GetBookingPageDocument);
const GetContactPageDocumentString = print(GetContactPageDocument);
const GetEventsPageDocumentString = print(GetEventsPageDocument);
const GetHomepageDataDocumentString = print(GetHomepageDataDocument);
const GetMeetingsPageDocumentString = print(GetMeetingsPageDocument);
const GetRestaurantPageDocumentString = print(GetRestaurantPageDocument);
const GetRoomBySlugDocumentString = print(GetRoomBySlugDocument);
const GetRoomsDocumentString = print(GetRoomsDocument);
const GetRoomsListPageDocumentString = print(GetRoomsListPageDocument);
const GetSiteSettignsDocumentString = print(GetSiteSettignsDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getBarPage(variables?: GetBarPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetBarPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetBarPageQuery>(GetBarPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBarPage', 'query');
    },
    getBookingPage(variables?: GetBookingPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetBookingPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetBookingPageQuery>(GetBookingPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBookingPage', 'query');
    },
    getContactPage(variables?: GetContactPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetContactPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetContactPageQuery>(GetContactPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getContactPage', 'query');
    },
    getEventsPage(variables?: GetEventsPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetEventsPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetEventsPageQuery>(GetEventsPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEventsPage', 'query');
    },
    getHomepageData(variables?: GetHomepageDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetHomepageDataQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetHomepageDataQuery>(GetHomepageDataDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHomepageData', 'query');
    },
    getMeetingsPage(variables?: GetMeetingsPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetMeetingsPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetMeetingsPageQuery>(GetMeetingsPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMeetingsPage', 'query');
    },
    getRestaurantPage(variables?: GetRestaurantPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetRestaurantPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetRestaurantPageQuery>(GetRestaurantPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRestaurantPage', 'query');
    },
    getRoomBySlug(variables?: GetRoomBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetRoomBySlugQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetRoomBySlugQuery>(GetRoomBySlugDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRoomBySlug', 'query');
    },
    getRooms(variables?: GetRoomsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetRoomsQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetRoomsQuery>(GetRoomsDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRooms', 'query');
    },
    getRoomsListPage(variables?: GetRoomsListPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetRoomsListPageQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetRoomsListPageQuery>(GetRoomsListPageDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRoomsListPage', 'query');
    },
    getSiteSettigns(variables?: GetSiteSettignsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: GetSiteSettignsQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<GetSiteSettignsQuery>(GetSiteSettignsDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSiteSettigns', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;